import { useMemo } from 'react';
import './Returns.scss';
import ProFormaReturnsTable from 'components/ProFormaReturnsTable/ProFormaReturnsTable';
import RenderIf from 'components/RenderIf/RenderIf';
import { isEmpty } from 'lodash';
import { getSaleIndexForCadence } from 'views/ProFormaTable/helpers';
import { useProFormaSocketContext } from '../../ProForma/socketContext/ProFormaSocketProvider';
import { getPeriodKeys, transformReturnsData } from './helpers';

const Returns = () => {
    const {
        returnsData, operatingInfo, showCents, periodCadence, proForma,
    } = useProFormaSocketContext();

    const saleIndex = getSaleIndexForCadence(operatingInfo.saleMonth, periodCadence);

    const transformedData = useMemo(() => transformReturnsData(returnsData, periodCadence), [returnsData, periodCadence]);
    const dateKeys = useMemo(() => getPeriodKeys(returnsData, periodCadence, saleIndex), [returnsData, periodCadence, saleIndex]);

    return (
        <RenderIf isTrue={!isEmpty(proForma)} isLoading={isEmpty(proForma)}>
            <div className="Returns">
                {transformedData && (
                    <ProFormaReturnsTable
                        showCents={showCents}
                        propertyReturns={transformedData}
                        dateKeys={dateKeys}
                        operationBeginMonth={operatingInfo.operationBeginMonth || 0}
                        cadence={periodCadence}
                    />
                )}
            </div>
        </RenderIf>
    );
};

export default Returns;
